import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CommunicationService {
  private userAccountId = new BehaviorSubject<number>(0);
  private accountEmail = new BehaviorSubject<any>('');
  private isSuperUser = new BehaviorSubject<any>(false);
  private isParentOrgSuperUser = new BehaviorSubject<any>(false);
  private isReadOnlyUser = new BehaviorSubject<any>(false);
  private orgId = new BehaviorSubject<any>(false);
  private parentOrgId = new BehaviorSubject<any>(false);
  private hasPropensityScoreAccess = new BehaviorSubject<any>(false);
  private hasSalesforceAccess = new BehaviorSubject<any>(false);
  private hasDeepCrawlAccessMessage = new BehaviorSubject<any>(false);
  private hasRecentAccountsAccessMessage = new BehaviorSubject<any>(false);
  private hasMultiplePostcodeSearchAccessMessage = new BehaviorSubject<any>(false);
  private hasEnergyAndEmissionsAccessMessage = new BehaviorSubject<any>(false);
  private hasPatentsAccessMessage = new BehaviorSubject<any>(false);
  private hasShareFilingsAccessMessage = new BehaviorSubject<any>(false);
  private hasGovernmentContractsAccessMessage = new BehaviorSubject<any>(false);
  private hasCompanyChargesAccessMessage = new BehaviorSubject<any>(false);
  private hasCompanyMatcherAccessMessage = new BehaviorSubject<any>(false);

  private hasCrossSellAccessMessage = new BehaviorSubject<any>(false);
  private hasAIPitchBuilderAccessMessage = new BehaviorSubject<any>(false);
  private hasSupplierDataAccessMessage = new BehaviorSubject<any>(false);
  private hasTerritoryAssignmentAccessMessage = new BehaviorSubject<any>(false);
  private hasZintGrowAccessMessage = new BehaviorSubject<any>(false);
  private hasAIAccountsSummaryAccess = new BehaviorSubject<any>(false);
  private hasSemanticSearchAccessMessage = new BehaviorSubject<any>(false);
  private hasCalendarIntegrationAccess = new BehaviorSubject<any>(false);
  private hasHubspotAccess = new BehaviorSubject<any>(false);
  private hasPipedriveAccess = new BehaviorSubject<any>(false);
  private hasDynamicsAccess = new BehaviorSubject<any>(false);
  private hasZohoAccess = new BehaviorSubject<any>(false);
  private hasAISearchAccess = new BehaviorSubject<any>(false);
  private hasAICompanyAssistantAccess = new BehaviorSubject<any>(false);
  private pageLimitFromPlan = new BehaviorSubject<any>(10);
  private hasAIRAAccess = new BehaviorSubject<boolean>(false);
  private hasPAFAccess = new BehaviorSubject<boolean>(false);
  private hasNYBAccess = new BehaviorSubject<boolean>(false);
  private hasClusterSearchAccess = new BehaviorSubject<boolean>(false);
  private availableDashboardSkins = new BehaviorSubject<string[]>([]);

  sendUserAccountId(userAccountId: number) {
    this.userAccountId.next(userAccountId);
  }
  sendEmailMessage(email: string) {
    this.accountEmail.next(email);
  }
  sendIsSuperUserMessage(isSuperUser: boolean) {
    this.isSuperUser.next(isSuperUser);
  }
  sendIsParentOrgSuperUserMessage(isParentOrgSuperUser: boolean) {
    this.isParentOrgSuperUser.next(isParentOrgSuperUser);
  }
  sendIsReadOnlyUserMessage(isReadOnlyUser: boolean) {
    this.isReadOnlyUser.next(isReadOnlyUser);
  }
  sendOrgIdMessage(orgId) {
    this.orgId.next(orgId);
  }
  sendParentOrgIdMessage(parentOrgId) {
    this.parentOrgId.next(parentOrgId);
  }
  sendHasPropensityScoreAccessMessage(hasPropensityScoreAccess: boolean) {
    this.hasPropensityScoreAccess.next(hasPropensityScoreAccess);
  }
  sendHasSalesforceAccess(hasSalesforceAccess: boolean) {
    this.hasSalesforceAccess.next(hasSalesforceAccess);
  }
  sendHasDeepCrawlAccessMessage(hasDeepCrawlAccessMessage: boolean) {
    this.hasDeepCrawlAccessMessage.next(hasDeepCrawlAccessMessage);
  }
  sendHasRecentAccountsAccessMessage(hasRecentAccountsAccessMessage: boolean) {
    this.hasRecentAccountsAccessMessage.next(hasRecentAccountsAccessMessage);
  }
  sendHasMultiplePostcodeSearchAccessMessage(
    hasMultiplePostcodeSearchAccessMessage: boolean
  ) {
    this.hasMultiplePostcodeSearchAccessMessage.next(
      hasMultiplePostcodeSearchAccessMessage
    );
  }
  sendHasEnergyAndEmissionsAccessMessage(
    hasEnergyAndEmissionsAccessMessage: boolean
  ) {
    this.hasEnergyAndEmissionsAccessMessage.next(
      hasEnergyAndEmissionsAccessMessage
    );
  }
  sendHasPatentsAccessMessage(hasPatentsAccessMessage: boolean) {
    this.hasPatentsAccessMessage.next(hasPatentsAccessMessage);
  }
  sendHasShareFilingsAccessMessage(hasShareFilingsAccessMessage: boolean) {
    this.hasShareFilingsAccessMessage.next(hasShareFilingsAccessMessage);
  }
  sendHasGovernmentContractsAccessMessage(
    hasGovernmentContractsAccessMessage: boolean
  ) {
    this.hasGovernmentContractsAccessMessage.next(
      hasGovernmentContractsAccessMessage
    );
  }
  sendHasCompanyChargesAccessMessage(hasCompanyChargesAccessMessage: boolean) {
    this.hasCompanyChargesAccessMessage.next(hasCompanyChargesAccessMessage);
  }
  sendHasCompanyMatcherAccessMessage(hasCompanyMatcherAccessMessage: boolean) {
    this.hasCompanyMatcherAccessMessage.next(hasCompanyMatcherAccessMessage);
  }
  sendHasZintGrowAccessMessage(hasZintGrowAccessMessage: boolean) {
    this.hasZintGrowAccessMessage.next(hasZintGrowAccessMessage);
  }
  sendHasCrossSellAccessMessage(hasCrossSellAccessMessage: boolean) {
    this.hasCrossSellAccessMessage.next(hasCrossSellAccessMessage);
  }
  sendHasAIPitchBuilderAccessMessage(hasAIPitchBuilderAccessMessage: boolean) {
    this.hasAIPitchBuilderAccessMessage.next(hasAIPitchBuilderAccessMessage);
  }

  sendHasSupplierDataAccessMessage(hasSupplierDataAccessMessage: boolean) {
    this.hasSupplierDataAccessMessage.next(hasSupplierDataAccessMessage);
  }

  sendHasTerritoryAssignmentAccessMessage(
    hasTerritoryAssignmentAccessMessage: boolean
  ) {
    this.hasTerritoryAssignmentAccessMessage.next(
      hasTerritoryAssignmentAccessMessage
    );
  }

  sendHasAIAccountsSummaryAccess(hasAIAccountsSummary: boolean) {
    this.hasAIAccountsSummaryAccess.next(hasAIAccountsSummary);
  }

  sendHasSemanticSearchAccessMessage(hasSemanticSearchAccessMessage: boolean) {
    this.hasSemanticSearchAccessMessage.next(hasSemanticSearchAccessMessage);
  }

  sendHasCalendarIntegrationAccessMessage(
    hasCalendarIntegrationAccess: boolean
  ) {
    this.hasCalendarIntegrationAccess.next(hasCalendarIntegrationAccess);
  }

  sendHasHubspotAccess(hasHubspotAccess: boolean) {
    this.hasHubspotAccess.next(hasHubspotAccess);
  }
  sendHasPipedriveAccess(hasPipedriveAccess: boolean) {
    this.hasPipedriveAccess.next(hasPipedriveAccess);
  }
  sendHasDynamicsAccess(hasDynamicsAccess: boolean) {
    this.hasDynamicsAccess.next(hasDynamicsAccess);
  }
  sendHasZohoAccess(hasZohoAccess: boolean) {
    this.hasZohoAccess.next(hasZohoAccess);
  }
  sendAISearchAccess(hasAISearchAccess: boolean) {
    this.hasAISearchAccess.next(hasAISearchAccess);
  }
  sendHasAICompanyAssistantAccess(hasAICompanyAssistantAccess: boolean) {
    this.hasAICompanyAssistantAccess.next(hasAICompanyAssistantAccess);
  }
  sendPageLimitFromPlan(pageLimitFromPlan: number) {
    this.pageLimitFromPlan.next(pageLimitFromPlan);
  }
  sendHasAIRAaccess(hasAIRAaccess: boolean) {
    this.hasAIRAAccess.next(hasAIRAaccess);
  }
  sendHasPAFAccess(hasPAFAccess: boolean) {
    this.hasPAFAccess.next(hasPAFAccess);
  }
  sendHasNYBAccess(hasNYBAccess: boolean) {
    this.hasNYBAccess.next(hasNYBAccess);
  }
  sendHasClusterSearchAccess(hasClusterSearchAccess: boolean) {
    this.hasClusterSearchAccess.next(hasClusterSearchAccess);
  }
  sendAvailableDashboardSkins(availableDashboardSkins: string[]) {
    this.availableDashboardSkins.next(availableDashboardSkins);
  }
  getUserAccountId(): Observable<number> {
    return this.userAccountId.asObservable();
  }
  getEmailMessage(): Observable<any> {
    return this.accountEmail.asObservable();
  }
  getIsSuperUserMessage(): Observable<any> {
    return this.isSuperUser.asObservable();
  }
  getIsParentOrgSuperUserMessage(): Observable<any> {
    return this.isParentOrgSuperUser.asObservable();
  }
  getIsReadOnlyUserMessage(): Observable<any> {
    return this.isReadOnlyUser.asObservable();
  }
  getOrgIdMessage(): Observable<any> {
    return this.orgId.asObservable();
  }
  getParentOrgIdMessage(): Observable<any> {
    return this.parentOrgId.asObservable();
  }
  getHasPropensityScoreAccessMessage(): Observable<any> {
    return this.hasPropensityScoreAccess.asObservable();
  }
  getSalesforceAccess(): Observable<any> {
    return this.hasSalesforceAccess.asObservable();
  }
  getHasDeepCrawlAccessMessage(): Observable<any> {
    return this.hasDeepCrawlAccessMessage.asObservable();
  }
  getHasRecentAccountsAccessMessage(): Observable<any> {
    return this.hasRecentAccountsAccessMessage.asObservable();
  }
  getHasMultiplePostcodeSearchAccessMessage(): Observable<any> {
    return this.hasMultiplePostcodeSearchAccessMessage.asObservable();
  }
  getHasEnergyAndEmissionsAccessMessage(): Observable<any> {
    return this.hasEnergyAndEmissionsAccessMessage.asObservable();
  }
  getHasPatentsAccessMessage(): Observable<any> {
    return this.hasPatentsAccessMessage.asObservable();
  }
  getHasShareFilingsAccessMessage(): Observable<any> {
    return this.hasShareFilingsAccessMessage.asObservable();
  }
  getHasGovernmentContractsAccessMessage(): Observable<any> {
    return this.hasGovernmentContractsAccessMessage.asObservable();
  }
  getHasCompanyChargesAccessAccessMessage(): Observable<any> {
    return this.hasCompanyChargesAccessMessage.asObservable();
  }
  getHasCompanyMatcherAccessMessage(): Observable<any> {
    return this.hasCompanyMatcherAccessMessage.asObservable();
  }
  getHasZintGrowAccessMessage(): Observable<any> {
    return this.hasZintGrowAccessMessage.asObservable();
  }
  getHasCrossSellAccessMessage(): Observable<any> {
    return this.hasCrossSellAccessMessage.asObservable();
  }
  getHasAIPitchBuilderAccessMessage(): Observable<any> {
    return this.hasAIPitchBuilderAccessMessage.asObservable();
  }
  getHasSupplierDataAccessMessage(): Observable<any> {
    return this.hasSupplierDataAccessMessage.asObservable();
  }
  getHasTerritoryAssignmentAccessMessage(): Observable<any> {
    return this.hasTerritoryAssignmentAccessMessage.asObservable();
  }
  getHasAIAccountsSummaryAccess(): Observable<any> {
    return this.hasAIAccountsSummaryAccess.asObservable();
  }
  getHasSemanticSearchAccessMessage(): Observable<any> {
    return this.hasSemanticSearchAccessMessage.asObservable();
  }
  getHasCalendarIntegrationAccess(): Observable<any> {
    return this.hasCalendarIntegrationAccess.asObservable();
  }
  getHubspotAccess(): Observable<any> {
    return this.hasHubspotAccess.asObservable();
  }
  getPipedriveAccess(): Observable<any> {
    return this.hasPipedriveAccess.asObservable();
  }
  getDynamicsAccess(): Observable<any> {
    return this.hasDynamicsAccess.asObservable();
  }
  getZohoAccess(): Observable<any> {
    return this.hasZohoAccess.asObservable();
  }
  getAISearchAccess(): Observable<any> {
    return this.hasAISearchAccess.asObservable();
  }
  getHasAICompanyAssistantAccessMessage(): Observable<any> {
    return this.hasAICompanyAssistantAccess.asObservable();
  }
  getPageLimitFromPlanMessage(): Observable<any> {
    return this.pageLimitFromPlan.asObservable();
  }
  getHasAIRAAccess(): Observable<any> {
    return this.hasAIRAAccess.asObservable();
  }
  getHasPAFAccess(): Observable<any> {
    return this.hasPAFAccess.asObservable();
  }
  getHasNYBAccess(): Observable<any> {
    return this.hasNYBAccess.asObservable();
  }
  getHasClusterSearchAccess(): Observable<boolean> {
    return this.hasClusterSearchAccess.asObservable();
  }
  getAvailableDashboardSkins(): Observable<string[]> {
    return this.availableDashboardSkins.asObservable();
  }
}
